import { gql, useLazyQuery } from "@apollo/client"
import { examScoreResult } from "./useLazyPlan"

const useLazyScoreByTask = (variables = {}) => {
    return useLazyQuery(
        gql`
            query (
                $taskId: ID!
            ) {
                getScoresByTaskId (
                    taskId: $taskId
                ) {
                    id
                    planId
                    taskId
                    examId
                    name
                    examScoreId
                    studentId
                    serviceId
                    examDate
                    overall
                    ${examScoreResult}
                }
            }
        `,
        { variables }
    )
}

export default useLazyScoreByTask